/*
 * Copyright (c) Dito Technologies
 */

export const ACCESS_TOKEN_KEY = "com.ditotechnologies.music.access_token"